import React, {useState, useEffect} from "react"
import styles from "./style.module.css"
import { useNavigate } from "react-router";
import { useDispatch } from 'react-redux';
import { IAccountFeature } from "../../models/IAccountFeature.model";
import { setAccountOpeningStep } from '../../redux/accountOpening';
import { accountTypes } from '../../utils/constants';
import { features as accountFeatures } from '../../mockData/accountFeatures'
interface ModalProps {
    openModal?: boolean;
    closeModal?: () => void;
    header?: string;
    newmessage?: string;
    paragraph?: string;
}
const Modal : React.FC<ModalProps> = ({ openModal = false, closeModal, header, paragraph, newmessage}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [accountDetails, setAccountDetails] = useState<IAccountFeature>()
    const [accountType, setAccountType] = useState(null)

    const [comingSoonPopup, setComingSoonPopup ] = useState<boolean>(false)
    const setAccountTypeToDisplay = () => {
      
           
         
                setAccountDetails(accountFeatures.swiftSavingsAccountDetails)
              
        }

        useEffect(() => {
            setAccountTypeToDisplay()
        }, [])

    
    const navigateToOpenAccount = () => {
        // if(props.accountType.toLowerCase() === 'minor savings'){
        //     setComingSoonPopup(true)
        //     return
        // }
        let accountStatus = localStorage.getItem('accountStatus')
        if(accountStatus === 'existing'){
            dispatch(setAccountOpeningStep('ex-bvn-validation'))
        }
        else{
            dispatch(setAccountOpeningStep('bvn-validation'))
        }
        navigate("/open-account")
    }

    const navigateToDocumentUpload = () => {
        dispatch(setAccountOpeningStep('document-upload'))
    }
    return (
        <>
        {openModal && (
            <div className={styles.overlay}>
                <div className={styles.modal}>
                    <div className={styles.modalContent}>
                        {/* <span className={styles.close} onClick={closeModal}>&times;</span> */}
                        <div className={styles.container}>
                         <h1>{header}</h1>
                         <p>{newmessage ? newmessage : paragraph ? paragraph : "Your mobile number does not match either your NIN or BVN. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details"}</p>
                         {/* <p>
                            The phone number linked to your BVN and NIN does not match. 
                            Please visit the nearest NIMC office to update your details. 
                            Kindly <span onClick={() => navigate("/personal-account")}>click here</span> to open a swift account with your BVN details</p> */}
                            <div className={styles.buttonContainer}>
                         <button onClick={closeModal} className={styles.firstButton}>Close</button>
                         {!newmessage && (
                             <button onClick={navigateToDocumentUpload} className={styles.secondButton}>Proceed</button>
                         )}
                        
                         </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    )
}

export default Modal;